import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
import { Banca } from '../../sdk/@types';
import BancaService from '../../sdk/services/BancaService';

interface BancaState {
  list: Banca.Banca[];
  banca?: Banca.Banca;
  fetching: boolean;
}

const initialState: BancaState = {
  list: [],
  banca: { id: '1' },
  fetching: false,
};

export const getTodasAsBancas = createAsyncThunk(
  'banca/getTodasAsBancas',
  async () => await BancaService.getBancas()
);

export const getBanca = createAsyncThunk(
  'banca/getBanca',
  async (banca: Banca.Banca) => await BancaService.getBanca(banca.id!)
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getTodasAsBancas, getBanca);
  const error = isRejected(getTodasAsBancas, getBanca);
  const loading = isPending(getTodasAsBancas, getBanca);

  builder
    .addCase(getTodasAsBancas.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(getBanca.fulfilled, (state, action) => {
      state.banca = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
